import React from 'react';
import axios from 'axios';
import {
    Grid,
    Button
} from '@material-ui/core/';
import { ModalInput } from './common';

type InfoText = {
    lineOne: string;
    lineTwo: string;
    lineThree: string;
    lineFour: string;
    lineFive: string;
    strongLine: string;
}

type InfoTextVariant = 'lineOne' | 'lineTwo' | 'lineThree' | 'lineFour' | 'lineFive' | 'strongLine';

interface Props {
    infoText: InfoText,
    setInfoText: React.Dispatch<React.SetStateAction<InfoText>>,
    infoTextId: string,
    onClose: () => void,
    API: string
}

function EditInfoTextModal( props: Props) {

    const {
        infoText,
        setInfoText,
        infoTextId,
        onClose,
        API
    } = props

    const onSubmit = () => {
        axios.patch(`${API}infoText/${infoTextId}`, infoText).catch(err => console.log('Error: ' + err));
        onClose();
    }

    const handleInfoTextChange = (variant: InfoTextVariant) => {
        const handleChange = (e: string) => setInfoText({
            lineOne: variant === 'lineOne' ? e : infoText.lineOne,
            lineTwo: variant === 'lineTwo' ? e : infoText.lineTwo,
            lineThree: variant === 'lineThree' ? e : infoText.lineThree,
            lineFour: variant === 'lineFour' ? e : infoText.lineFour,
            lineFive: variant === 'lineFive' ? e : infoText.lineFive,
            strongLine: variant === 'strongLine' ? e : infoText.strongLine,
        });

        return handleChange;
    }

    return (
        <form onSubmit={onSubmit}>
            <Grid container direction='column' style={{ width: '30vw', minWidth: '270px'}}>
                <ModalInput  value={infoText.lineOne} multiline onChange={handleInfoTextChange('lineOne')}/>
                <ModalInput  value={infoText.lineTwo} multiline onChange={handleInfoTextChange('lineTwo')}/>
                <ModalInput  value={infoText.lineThree} multiline onChange={handleInfoTextChange('lineThree')}/>
                <ModalInput  value={infoText.lineFour} multiline onChange={handleInfoTextChange('lineFour')}/>
                <ModalInput  value={infoText.lineFive} multiline onChange={handleInfoTextChange('lineFive')}/>
                <ModalInput  value={infoText.strongLine} multiline onChange={handleInfoTextChange('strongLine')}/>
                <Grid container justify='center' style={{ padding: '8px'}}>
                    <Button 
                        variant='contained' 
                        color='primary'
                        onClick={() => onSubmit()}
                    >
                        Uložit
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default EditInfoTextModal;